import { dark, light } from '@space-lib/styles/themes'

import { Colors, FixedColorsHex } from '@space-lib/styles/themes/enum'

import { CHANNEL, LUMINANCE_ADD, MAX_RGB, NUMERIC_VALUES, PARSE_RGB } from './constants'

import type { RgbColor } from './types'

class CustomColorsUtils {
  static getLuminance(color: string): number {
    const rgbColor = this.parseToRgb(color)
    const [r, g, b] = Object.keys(rgbColor).map((key) => {
      const channel = rgbColor[key] / MAX_RGB

      return channel <= CHANNEL.CONDITION
        ? channel / CHANNEL.FIRST_DIVISOR
        : ((channel + CHANNEL.ADD) / CHANNEL.SECOND_DIVISOR) ** CHANNEL.MULTIPLIER
    })

    return parseFloat(
      (PARSE_RGB.R * r + PARSE_RGB.G * g + PARSE_RGB.B * b).toFixed(NUMERIC_VALUES.THREE)
    )
  }

  static getContrast(firstColor?: string, secondColor?: string): number {
    if (!firstColor || !secondColor) {
      return NUMERIC_VALUES.ZERO
    }
    const firstLuminance = this.getLuminance(firstColor)
    const secondLuminance = this.getLuminance(secondColor)

    return parseFloat(
      (firstLuminance > secondLuminance
        ? (firstLuminance + LUMINANCE_ADD) / (secondLuminance + LUMINANCE_ADD)
        : (secondLuminance + LUMINANCE_ADD) / (firstLuminance + LUMINANCE_ADD)
      ).toFixed(NUMERIC_VALUES.TWO)
    )
  }

  static getBestContrastColor(backgroundColor?: string): string {
    const contrastLight = this.getContrast(backgroundColor, light.colors.gray900)
    const contrastDark = this.getContrast(backgroundColor, dark.colors.gray900)
    if (contrastDark > contrastLight) {
      return dark.colors.gray900
    }

    return light.colors.gray900
  }

  static isFixedColor(color?: string): boolean {
    if (!color) {
      return false
    }

    return Object.keys(Colors).includes(color) || Object.keys(FixedColorsHex).includes(color)
  }

  static parseToRgb(color: string): RgbColor {
    return {
      red: parseInt(
        `${color[NUMERIC_VALUES.ONE]}${color[NUMERIC_VALUES.TWO]}`,
        NUMERIC_VALUES.SIXTEEN
      ),
      green: parseInt(
        `${color[NUMERIC_VALUES.THREE]}${color[NUMERIC_VALUES.FOUR]}`,
        NUMERIC_VALUES.SIXTEEN
      ),
      blue: parseInt(
        `${color[NUMERIC_VALUES.FIVE]}${color[NUMERIC_VALUES.SIX]}`,
        NUMERIC_VALUES.SIXTEEN
      )
    }
  }
}

export default CustomColorsUtils
